var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Add / Filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Q2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sale->-Item->--Promotion-Selected-b",
    transform: "translate(-800.000000, -28.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars-/-Top-Bar-/-Menu-Expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons",
    transform: "translate(718.000000, 3.960784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Copy",
    transform: "translate(66.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Contained-/-Enabled-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Add-/-Filled",
    transform: "translate(17.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.500000, 3.500000)",
    fill: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77040816,0 C1.80390985,0 1.02040816,0.783501688 1.02040816,1.75 C1.02040816,2.71649831 1.80390985,3.5 2.77040816,3.5 C3.73690648,3.5 4.52040816,2.71649831 4.52040816,1.75 C4.52040816,0.783501688 3.73690648,0 2.77040816,0 L2.77040816,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87244898,6.81114551 C6.90595067,6.81114551 6.12244898,7.5946472 6.12244898,8.56114551 C6.12244898,9.52764382 6.90595067,10.3111455 7.87244898,10.3111455 C8.83894729,10.3111455 9.62244898,9.52764382 9.62244898,8.56114551 C9.62244898,7.5946472 8.83894729,6.81114551 7.87244898,6.81114551 L7.87244898,6.81114551 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1.43877551 10.0206767 10.2040816 1.66242813 8.76530612 0.290468819 -2.52331489e-12 8.64871738"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,0.2 C0.98497355,0.2 0,1.18497355 0,2.4 L0,6.8 C1.221,6.8 2.2,7.79 2.2,9 C2.2,10.2150264 1.21502645,11.2 0,11.2 L0,15.6 C0,16.8150264 0.98497355,17.8 2.2,17.8 L19.8,17.8 C21.0150264,17.8 22,16.8150264 22,15.6 L22,11.2 C20.7849736,11.2 19.8,10.2150264 19.8,9 C19.8,7.779 20.79,6.8 22,6.8 L22,2.4 C22,1.179 21.01,0.2 19.8,0.2 L2.2,0.2",
    id: "Path",
    stroke: "#757575",
    strokeWidth: 2
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/Coupon.b08a3e33.svg";
export { ForwardRef as ReactComponent };